// extracted by mini-css-extract-plugin
export default {"doblons":"styles_doblons__a0MKi","headerFull":"styles_headerFull__OHybd"};